export const numberToWords = (number) => {
    var num = "Zero One Two Three Four Five Six Seven Eight Nine Ten Eleven Twelve Thirteen Fourteen Fifteen Sixteen Seventeen Eighteen Nineteen".split(" ");
    var tens = "Twenty Thirty Forty Fifty Sixty Seventy Eighty Ninety".split(" ");

    const noToWords = (n) => {
        if (n < 20) return num[n];
        var digit = n%10;
        if (n < 100) return tens[~~(n/10)-2] + (digit? "-" + num[digit]: "");
        if (n < 1000) return num[~~(n/100)] +" Hundred" + (n%100 === 0? "": " and " + noToWords(n%100));
        if (n < 1000000) return noToWords(~~(n/1000)) + " Thousand" + (n%1000 !== 0? " " + noToWords(n%1000): "");
        if (n < 1000000000) return noToWords(~~(n/1000000)) + " Million" + (n%1000000 !== 0? " " + noToWords(n%1000000): "");
        return noToWords(~~(n/1000000000)) + " Billion" + (n%1000000000 !== 0? " " + noToWords(n%1000000000): "");
    
    }

    return noToWords(number) + " Naira Only";

}